import { harvestWeightUnits, storedScaleFormat } from "@common/helpers/harvestWeightUnit";
import type { ScaleVariant } from "@common/helpers/scaleInput";
import type { UserSettings } from "@common/types/User";

export const getCachedWeightUnit = (
  cacheKey: string,
  unitPreference: UserSettings["unitPreference"],
  fallback = harvestWeightUnits(unitPreference).small
): string => {
  const { big, small } = harvestWeightUnits(unitPreference);
  const stored = localStorage.getItem(cacheKey);
  const cached = stored === "lbOz" ? "lb" : stored;

  return cached === small || cached === big ? cached : fallback;
};

export const getCachedScaleFormat = (
  cacheKey: string,
  unitPreference: UserSettings["unitPreference"],
  fallback: ScaleVariant
): ScaleVariant =>
  storedScaleFormat(localStorage.getItem(cacheKey), unitPreference, fallback);

export const persistWeightUnit = (cacheKey: string, unit: string): void => {
  localStorage.setItem(cacheKey, unit);
};
